import { SchedulerStatus } from '@analyzer/client';
import { useQuery } from '@tanstack/react-query';
import { useService } from '../providers/ServiceProvider';

export function useSchedulerStatusQuery() {
  const client = useService();
  return useQuery<SchedulerStatus, Error>(['scheduler-status'], () => client.schedulerStatus(), {
    refetchInterval: 5000
  });
}
